import CodeSwitcherPage from "../../../../src/mdx/resources/code-examples";
import * as React from 'react';
export default {
  CodeSwitcherPage,
  React
};